import { Component, OnInit } from '@angular/core';
import { HeaderBreadcrumbService } from 'src/app/components/header-components/header-breadcrumb/header-breadcrumb.service';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { BRoute } from 'src/app/models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model';

@Component({
  selector: 'app-users-new-user-dashboard',
  templateUrl: './users-new-user-dashboard.component.html',
  styleUrls: ['./users-new-user-dashboard.component.scss']
})
export class UsersNewUserDashboardComponent implements OnInit {

  constructor(private headerBreadcrumbService: HeaderBreadcrumbService) { }

  ngOnInit() {
    this.setBreadcrumb();
  }

  public setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-user', 'users-page.new user', '/account/users', [new BRoute('account-page.account', '/account'), new BRoute('users-page.users', '/account/users'), new BRoute('users-page.new user')]));
  }

}
